'use client';

const variantColor = {
  default: "onLight.text.primary",
  destructive: "action.destructive.dark",
  upsell: "action.upsell.dark"
};
export {
  variantColor
};
